export default function usePlural(count: number, singularKey : string, pluralKey : string) {
    return count % 10 === 1 && count % 100 !== 11
        ? singularKey
        : pluralKey;
}
